import {Injectable} from '@angular/core';
import {first} from 'rxjs/operators';
import {ConfiguratorUriParameterService, ProductCodes} from '@dcp/configurator';
import {DcpProductService} from '../../services/dcp-product.service';
import {ConfiguratorProductService} from './configurator-product.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ConfigureUrlErrorService {

  productCode: string;

  constructor(
    private uriParamService: ConfiguratorUriParameterService,
    private dcpProductService: DcpProductService,
    private configuratorProductService: ConfiguratorProductService,
  ) {
  }

  setProductsFromUrl() {
    this.productCode = this.uriParamService.getProduct();
    if (this.productCode) {
      this.dcpProductService.getProductCodesBySupplierAlternativeAid(this.productCode)
        .pipe(first(), untilDestroyed(this))
        .subscribe((data: ProductCodes) => {
          this.configuratorProductService.setVariantProduct(data.code);
          this.configuratorProductService.setDisplayProduct(data.displayProductCode);
        });
    }
  }

  getActionTypeFromUrl() {
    return this.uriParamService.getAction();
  }
}
